module.exports = __webpack_public_path__ + "media/video-start.eb8a2418.webm";